import {
  FETCH_CMS_MTO_REQUEST,
  FETCH_CMS_MTO_UPDATE,
  FETCH_CMS_DELIVERY_REQUEST,
  FETCH_CMS_DELIVERY_UPDATE
} from '../../actionTypes/cmsActionTypes'

const fetchCmsMtoRequest = () => ({
  type: FETCH_CMS_MTO_REQUEST
})

const fetchCmsMtoUpdate = payload => ({
  type: FETCH_CMS_MTO_UPDATE,
  payload
})

const fetchCmsDeliveryRequest = () => ({
  type: FETCH_CMS_DELIVERY_REQUEST
})

const fetchCmsDeliveryUpdate = payload => ({
  type: FETCH_CMS_DELIVERY_UPDATE,
  payload
})

export { fetchCmsMtoRequest, fetchCmsMtoUpdate, fetchCmsDeliveryRequest, fetchCmsDeliveryUpdate }
